module.exports = __webpack_public_path__ + "img/suzhou.06dfa4c.png";